export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="m8.223 12.4-2.85 2.85H20.5v1.5H5.373l2.85 2.85-1.07 1.053L2.5 16l4.653-4.653 1.07 1.053ZM21.5 8l-4.653 4.653-1.07-1.053 2.85-2.85H3.5v-1.5h15.127l-2.85-2.85 1.07-1.053L21.5 8Z"/>
</svg>
`;
